import { memo } from 'react'
import { Box } from '@mui/material'
import OiAnalysisChartPanel from '../OiAnalysisChartPanel'
import { OiChartRow } from '../oiChartData'

type Props = {
    data: OiChartRow[]
    /** Thinner bars for narrow containers such as the right sidebar. */
    compactBars?: boolean
}

/** Read-only preview of the OI Analysis bar chart — it brings its own axes and legend. */
const OverviewMiniBarChart = ({ data, compactBars }: Props) => {
    if (!data.length) {
        return (
            <Box
                sx={{
                    flex: 1,
                    minHeight: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'text.secondary',
                    fontSize: '0.8125rem',
                }}
            >
                No data
            </Box>
        )
    }

    return (
        <Box sx={{ flex: 1, minHeight: 0, height: '100%', width: '100%' }}>
            <OiAnalysisChartPanel
                chartData={data}
                showOI={false}
                replayKey={0}
                compactBars={compactBars}
            />
        </Box>
    )
}

export default memo(OverviewMiniBarChart)
